import { designCopy } from "../design/copy.ts";
import { plural } from "../design/format/numbers.ts";

export const agencyCopy = {
  lugares: { clientes: "Clientes", equipe: "Equipe", sair: "Sair" },
  inicio: {
    intro: "Cada cliente com os próprios números, lado a lado. A Nabla nunca soma clientes.",
    nadaEsperando: "Nada esperando você em nenhum cliente.",
    nenhum: "Nenhum cliente ainda. Peça a quem administra a agência para dar acesso a você.",
    liberando: (n: number) =>
      `O acesso a ${n} ${plural(n, "cliente", "clientes")} do seu convite ainda está sendo liberado. Volte em instantes.`,
  },
  cartao: {
    abrir: "Abrir",
    semResposta: "Este cliente não respondeu agora. Abra-o para ver.",
    esperam: (n: number) => (n === 0 ? designCopy.nadaEsperando : `${n} ${plural(n, "mudança espera", "mudanças esperam")} você.`),
    alertas: (n: number) => `${n} ${plural(n, "alerta", "alertas")}`,
    decisoes: "Últimas decisões da Nabla",
    leitura: (hora: string) => `Dados lidos às ${hora}`,
  },
  equipe: {
    intro: "Quem da agência acompanha cada cliente, e com que papel.",
    papeis: { admin: "Admin", gestor: "Gestor" },
    dar: (papel: string) => `Dar acesso como ${papel}`,
    tirar: "Tirar acesso",
    pendente: "acesso pendente",
    cancelar: "Cancelar acesso",
    tornar: (papel: string) => `Tornar ${papel} da agência`,
    naAgencia: (papel: string) => `${papel} da agência`,
    semResposta: "A Nabla ainda não respondeu. Recarregue em instantes e veja se mudou antes de tentar de novo.",
    semLeitura: "O convite não dá mais este cliente, mas o cliente não respondeu: não deu para ver se o acesso já tinha chegado. "
      + "Tire de novo em instantes.",
  },
  convite: {
    titulo: (agencia: string) => `Você tem um convite para a ${agencia} na Nabla.`,
    vencido: "Este convite venceu. Peça um novo a quem administra a agência.",
  },
  sessao: {
    sairPergunta: "Sair da agência neste aparelho?",
    sairExplica: "Você sai da agência e de cada cliente que abriu por ela neste aparelho.",
    voltar: "Voltar",
    saiu: "Você saiu.",
    terminou: "Sua sessão na agência terminou.",
    terminouExplica: "Abra um link de convite da agência. Peça um a quem a administra.",
  },
  naoEncontrado: "Este cliente não está entre os que você acompanha.",
  naoCarregou: "Esta página não carregou.",
} as const;
